import React, { useState, Fragment, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormComposer, Header, MultiLink } from "@egovernments/digit-ui-react-components";
import { newConfig as newConfigFI } from "../../../config/InspectionReportConfig";
import get from "lodash/get";
import orderBy from "lodash/orderBy";
import { Card, Container } from "@material-ui/core";
import ApplicationDetailsForm11 from "../../../../../templates/ApplicationDetails/form11";
import { NOCService } from "../../../../../../../packages/libraries/src/services/elements/NOC";
// import HouseIcon from '@mui/icons-material/House';

const SUBApplicationForm11 = () => {
  const { authority, state, plan, plinth, form, year, serial, formType, id: urlId } = useParams(); //:authority/:plan/:form/:year/:serial
  console.log(useParams(), "paramsHook");

  const id = plinth
    ? `${authority}/${plinth}/${plan}/${form}/${year}/${serial}`
    : urlId
    ? urlId
    : state
    ? `${state}/${form}/${year}/${serial}`
    : `${authority}/${plan}/${form}/${year}/${serial}`;
  console.log("loggingIdFromComp", id, urlId);
  const nocAppData = Digit.SessionStorage.get("nocAppData");
  const { t } = useTranslation();
  console.log("nocAppData", nocAppData, useParams(), "paramsHook");
  const tenantId = Digit.ULBService.getCurrentTenantId();

  const [showToast, setShowToast] = useState(null);
  const [canSubmit, setSubmitValve] = useState(false);
  const [filters, setFilters] = useState(null); // <-- Add filters state
  const defaultValues = {};
  const history = useHistory();
  const [_formData, setFormData, _clear] = Digit.Hooks.useSessionStorage("store-data", null);
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_HAPPENED", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_SUCCESS_DATA", {});
  const [error, setError] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const { isLoading: bpaDocsLoading, data: bpaDocs } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"]);
  let { data: newConfig } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const { isMdmsLoading, data: mdmsData } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["RiskTypeComputation"]);
  const isEmployee = history.location.pathname.includes("citizen");

  // Dynamically set filters using useEffect (like indexForm.js)
  useEffect(() => {
    if (formType !== "NOC") {
      console.log("insideeffect", formType);

      setFilters({
        applicationNo: id,
        isEmployee,
        formType,
      });
      return;
    }

    const fetchNocData = async () => {
      try {
        const response = await NOCService.NOCsearch({ tenantId: "up", filters: { applicationNo: id } });
        console.log("responseFromNOCSearch", response);
        setFilters({
          applicationNo: response?.Noc?.[0]?.sourceRefId,
          isEmployee,
          formType: "FORM_MAP",
        });
      } catch (err) {
        console.error("Error in NOCsearch:", err);
      }
    };

    fetchNocData();
  }, [tenantId, id, isEmployee, formType]);

  // Use filters in your data fetching hook
  const { data = {}, isLoading } = Digit.Hooks.obps.useBPADetailsPage(stateId, filters, {
    formType,
    config: {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      // refetchOnWindowFocus: true,
      // refetchOnReconnect: true,
    },
  });
  const { collectionBillRes, collectionBillDetails } = data;
  const appData = data?.LandUse?.[0] || data?.PurchasableFAR?.[0] || data?.BPA?.[0];
  if (!isLoading && appData) {
    appData.paymentDetails = collectionBillRes?.[0]?.paymentDetails?.[0];
  }
  console.log("isDataForm11", formType, stateId, data, bpaDocs, newConfig, mdmsData);
  console.log("appData", appData, data, isLoading);
  const [showOptions, setShowOptions] = useState(false);
  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate,
  } = Digit.Hooks.obps.useApplicationActions(stateId, formType);

  const nocMutation = Digit.Hooks.obps.useObpsAPI(tenantId, true);
  function checkHead(head) {
    if (head === "ES_NEW_APPLICATION_LOCATION_DETAILS") {
      return "TL_CHECK_ADDRESS";
    } else if (head === "ES_NEW_APPLICATION_OWNERSHIP_DETAILS") {
      return "TL_OWNERSHIP_DETAILS_HEADER";
    } else {
      return head;
    }
  }
  const closeToast = () => {
    setShowToast(null);
    setError(null);
  };
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
  }, []);
  const onFormValueChange = (setValue, formData, formState) => {
    setSubmitValve(!Object.keys(formState.errors).length);
  };
  let configs = newConfig?.InspectionReportConfig ? newConfig?.InspectionReportConfig : newConfigFI;

  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: appData?.businessService,
  });

  if (workflowDetails && workflowDetails.data && !workflowDetails.isLoading) {
    workflowDetails.data.initialActionState = workflowDetails?.data?.initialActionState || { ...workflowDetails?.data?.actionState } || {};
    workflowDetails.data.actionState = { ...workflowDetails.data };
  }
  const userInfo = Digit.UserService.getUser();
  if (workflowDetails?.data?.processInstances?.length > 0) {
    let filteredActions = [];
    filteredActions = get(workflowDetails?.data?.processInstances[0], "nextActions", [])?.filter((item) => item.action != "ADHOC");
    let actions = orderBy(filteredActions, ["action"], ["desc"]);
    if ((!actions || actions?.length == 0) && workflowDetails?.data?.actionState) workflowDetails.data.actionState.nextActions = [];
  }
  if (workflowDetails?.data?.nextActions?.length > 0) {
    workflowDetails.data.nextActions = workflowDetails?.data?.nextActions?.filter((actn) => actn.action !== "INITIATE");
    workflowDetails.data.nextActions = workflowDetails?.data?.nextActions?.filter((actn) => actn.action !== "ADHOC");
  }

  let dowloadOptions = [];

  if (workflowDetails?.data?.nextActions?.length > 0) {
    workflowDetails.data.nextActions = workflowDetails?.data?.nextActions?.filter((actn) => actn.action !== "SKIP_PAYMENT" && actn.action !== "EDIT");
  }

  return (
    <Fragment>
      {/* <div className={"employee-main-application-details"}> */}

      {/* <Card style={{marginLeft:"200px"}}> */}
      {!isLoading && appData && (
        <React.Fragment>
          {/* <Card style={{margin: "15px 0px 15px",padding: "8px" , position: "relative" }} className={"employeeCard-override"}>
           <HouseIcon style={{ color: 'red' }} /> Take Action</Card> */}
          <div>
            <ApplicationDetailsForm11
              applicationDetails={appData}
              isLoading={updatingApplication}
              isDataLoading={updatingApplication}
              applicationData={appData}
              nocMutation={nocMutation}
              mutate={mutate}
              workflowDetails={workflowDetails}
              businessService={
                workflowDetails?.data?.applicationBusinessService ? workflowDetails?.data?.applicationBusinessService : appData?.businessService
              }
              moduleCode={appData?.businessService}
              showToast={showToast}
              ActionBarStyle={isMobile ? {} : { paddingRight: "50px" }}
              MenuStyle={isMobile ? {} : { right: "50px" }}
              setShowToast={setShowToast}
              closeToast={closeToast}
              statusAttribute={"state"}
              timelineStatusPrefix={`WF_${
                workflowDetails?.data?.applicationBusinessService ? workflowDetails?.data?.applicationBusinessService : appData?.businessService
              }_`}
            />
          </div>
        </React.Fragment>
      )}
      {/* </Card> */}
      {/* </div> */}
    </Fragment>
  );
};

export default SUBApplicationForm11;
